import React, {useState} from 'react';
import Home from "../components/Homepage";
import "./custompages.css";
import {useKeycloak} from "@react-keycloak/web";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const Reports = () => {

    let displayErrorMonthly;
    let displayErrorDaily;
    const { keycloak, initialized } = useKeycloak();
    let url = window.location.href
    let arr = url.split("/");
    console.log(arr);
    url = arr[0] + "//" + arr[2] + "/reportMonthly";
    const urlDaily = arr[0] + "//" + arr[2];
    let org_id = null;
    if (keycloak.resourceAccess && keycloak.resourceAccess.portal_client && keycloak.resourceAccess.portal_client.roles) {

        org_id = keycloak.resourceAccess.portal_client.roles;
    }
    console.log("--------------");
    if (Array.isArray(org_id) && org_id.length > 1) {
        console.log("More than one OrgID!")
        org_id = null;
    } else {
        console.log("One OrgID!")
    }

    function sendReportRequest(type, date) {
        fetch(url, {
            method: 'POST',
            headers: {
                'Authorization':'Bearer ' + keycloak.token,
                'Content-Type': 'text/plain;charset=UTF-8'
            },
            body:JSON.stringify( {
                'Date': date,
                'ExportType': type,
            })
        })
            .then(async res => {
                displayErrorMonthly = "";
                document.getElementById("displayErrorMonthly").innerHTML = displayErrorMonthly;
                document.getElementById("displayErrorMonthly").style.fontWeight = "bold";
                console.log(res);

                if(res.status === 204) {
                    displayErrorMonthly = "No records to display";
                    document.getElementById("displayErrorMonthly").style.color = "red";
                    document.getElementById("displayErrorMonthly").innerHTML = displayErrorMonthly;
                } else {
                    const filename = res.headers.get("Content-Disposition").match(/filename=(.+)/)[1];
                    console.log("Downloaded file: " + filename);
                    const encodedUri = URL.createObjectURL(await res.blob());
                    const link = document.createElement("a");

                    link.setAttribute("href", encodedUri);
                    link.setAttribute("download", filename);
                    document.body.appendChild(link);
                    link.click();
                }
            })
            .catch(err => console.error(err))
    }


    function sendReportRequestExOut(url,date,type) {
        fetch(url, {
            method: 'POST',
            headers: {
                'Authorization':'Bearer ' + keycloak.token,
                'Content-Type': 'text/plain;charset=UTF-8'
            },
            body:JSON.stringify( {
                'Date': date,
                'ExportType': type,
            })
        })
            .then(async res => {
                displayErrorDaily = "";
                document.getElementById("displayErrorDaily").innerHTML = displayErrorDaily;
                document.getElementById("displayErrorDaily").style.fontWeight = "bold";

                console.log(res);

                if (res.status === 204) {
                    displayErrorDaily = "No records to display";
                    document.getElementById("displayErrorDaily").style.color = "red";
                    document.getElementById("displayErrorDaily").innerHTML = displayErrorDaily;
                } else {
                    const filename = res.headers.get("Content-Disposition").match(/filename=(.+)/)[1];
                    console.log("Downloaded file: " + filename);
                    const encodedUri = URL.createObjectURL(await res.blob());
                    const link = document.createElement("a");

                    link.setAttribute("href", encodedUri);
                    link.setAttribute("download", filename);
                    document.body.appendChild(link);
                    link.click();
                }
            })
            .catch(err => console.error(err))
    }




    const handleSubmitMonthly = (event) => {
        event.preventDefault();
        let type = false;
        if(downloadTypeMonthly === "Csv")
            type = true;
        if(dateToYMD(valueMonthly))
            sendReportRequest(type, dateToYMD(valueMonthly));
        else
            console.log("Date not selected!"); //TODO: maybe put span with message

        console.log(displayErrorMonthly);
    }

    const handleSubmitDailyExOut = (event) => {
        event.preventDefault();
        let type = false;
        if(downloadType === "Json")
            type = true;
        if(dateToYMD(value))
            sendReportRequestExOut(urlDaily + "/reportExOutDaily",dateToYMD(value), type);
        else
            console.log("Date not selected!"); //TODO: maybe put span with message

        console.log(displayErrorDaily);
    }

    const handleSubmitDailyExIn = (event) => {
        event.preventDefault();
        let type = false;
        if(downloadType === "Json")
            type = true;
        if(dateToYMD(value))
            sendReportRequestExOut(urlDaily + "/reportExInDaily", dateToYMD(value), type);
        else
            console.log("Date not selected!"); //TODO: maybe put span with message
    }


    function getPreviousMonth(previous) {
        previous.setMonth(previous.getMonth()-1);

        return previous;
    }

    const monthRestriction = new Date();


    //need yyyy.MM.dd
    const [value,onChange] = useState(new Date());
    const [valueMonthly,onChangeMonthly] = useState(getPreviousMonth(monthRestriction));

    console.log("MONTHLY DATE")
    console.log(valueMonthly)

    function dateToYMD(date) {
        if(date != null) {
            var d = date.getDate();
            var m = date.getMonth() + 1; //Month from 0 to 11
            var y = date.getFullYear();
            return '' + y + '.' + (m <= 9 ? '0' + m : m) + '.' + (d <= 9 ? '0' + d : d);
        }
        return false;
    }


    console.log("Selected date for daily report: " + dateToYMD(value));
    console.log("Selected date for monthly report: " + dateToYMD(valueMonthly));
    const [downloadType, setDownloadType] = useState("Json");
    const [downloadTypeMonthly, setDownloadTypeMonthly] = useState("Csv");

    return (
        <>
            <Home/>
            <div className="main-container">
                <div><h5 className="header">Reports</h5></div>
                <div className="report-wrap container-fluid">
                    <div className="report-container container-fluid">
                        <div className="row" style={{height: "6%"}}>
                            <h5 className="header"><b>Search</b></h5>
                        </div>
                        <div className="report-body row">
                            <div className="col report-variable">
                                <div className="row heading-row">
                                    <div className="response-heading">
                                        <p>Daily reports</p>
                                    </div>
                                </div>
                                <div className="row" style={{height: "13%"}}>
                                    <div className="col">
                                        <div className="date-wrapper">
                                            <DatePicker className="report-date" dateFormat="yyyy/MM/dd" selected={value}
                                                        onChange={onChange} maxDate={new Date()}/>
                                        </div>
                                    </div>
                                    <div className="col" style={{width: "20%"}}>
                                        <select id="downloadType" className="download-type" name="downloadType"
                                                value={downloadType} onChange={(e) => setDownloadType(e.target.value)}>
                                            <option value="Json">Json</option>
                                            <option value="Txt">Txt</option>
                                        </select>
                                    </div>
                                </div>
                                {org_id !== null ? (
                                <div className="row download-button">
                                    <button className="button-report check-btn"
                                            onClick={handleSubmitDailyExOut}>Download Out
                                    </button>
                                    <button className="button-report check-btn" onClick={handleSubmitDailyExIn}>Download
                                        In
                                    </button>
                                </div>
                                ) : (
                                    <p>OrgId is misssing. Buttons are disabled.</p>
                                )}
                                <div className="row displayError">
                                    <span id="displayErrorDaily"/>
                                </div>
                            </div>
                            <div className="col report-variable">
                                <div className="row heading-row">
                                    <div className="response-heading">
                                        <p>Monthly reports</p>
                                    </div>
                                </div>
                                <div className="row" style={{height: "13%"}}>
                                    <div className="col">
                                        <div className="date-wrapper">
                                            <DatePicker className="report-date" dateFormat="MM/yyyy" showMonthYearPicker
                                                        selected={valueMonthly} onChange={onChangeMonthly}
                                                        maxDate={monthRestriction}/>
                                        </div>
                                    </div>
                                    <div className="col" style={{width: "20%"}}>
                                        <select id="downloadTypeMonthly" className="download-type"
                                                name="downloadTypeMonthly" value={downloadTypeMonthly}
                                                onChange={(e) => setDownloadTypeMonthly(e.target.value)}>
                                            <option value="Csv">Csv</option>
                                            <option value="Excel">Excel</option>
                                        </select>
                                    </div>
                                </div>
                                {org_id !== null ? (
                                    <div className="row download-button">
                                        <button className="button-report check-btn"
                                                onClick={handleSubmitMonthly}>Download
                                        </button>
                                    </div>
                                ) : (
                                    <p>OrgId is misssing. Buttons are disabled.</p>
                                )}
                                <div className="row displayError">
                                    <span id="displayErrorMonthly"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Reports;
